import { render, staticRenderFns } from "./WaistCard.vue?vue&type=template&id=5aa38048&scoped=true&"
import script from "./WaistCard.vue?vue&type=script&lang=js&"
export * from "./WaistCard.vue?vue&type=script&lang=js&"
import style0 from "./WaistCard.vue?vue&type=style&index=0&id=5aa38048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa38048",
  null
  
)

export default component.exports